import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateGet = {
    path: "/affiliate",
    method: ERouteHttpVerb.GET
};
export { routeLocationAffiliateGet };
